"use strict";

var copies = require('./copies');

var doNotShrink = require('./doNotShrink');

var doNotShrinkSmallQuantities = require('./doNotShrinkSmallQuantities');

var doubledCopies = require('./doubledCopies');

var tableNumberQueue = require('./tableNumberQueue');

var reprintNotes = require('./reprintNotes');

var quantity = require('./quantity');

var quantityPlus = require('./quantityPlus');

var twoSetsNeeded = require('./twoSetsNeeded');

var defectCheck = require('./defectCheck');

var twoCopiesNeeded = require('./twoCopiesNeeded');

var backsidePrinting = require('./backsidePrinting');

module.exports = {
  copies: copies,
  twoSetsNeeded: twoSetsNeeded,
  doNotShrink: doNotShrink,
  doNotShrinkSmallQuantities: doNotShrinkSmallQuantities,
  doubledCopies: doubledCopies,
  tableNumberQueue: tableNumberQueue,
  reprintNotes: reprintNotes,
  quantity: quantity,
  quantityPlus: quantityPlus,
  defectCheck: defectCheck,
  twoCopiesNeeded: twoCopiesNeeded,
  backsidePrinting: backsidePrinting
};